function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5789 26.3643H55.1807C55.9871 26.3643 56.7605 26.6846 57.3308 27.2549C57.901 27.8251 58.2214 28.5985 58.2214 29.405C58.2214 30.2114 57.901 30.9848 57.3308 31.5551C56.7605 32.1253 55.9871 32.4457 55.1807 32.4457H3.04072C2.23427 32.4457 1.46085 32.1253 0.890606 31.5551C0.320361 30.9848 0 30.2114 0 29.405C0 28.5985 0.320361 27.8251 0.890606 27.2549C1.46085 26.6846 2.23427 26.3643 3.04072 26.3643H11.5789Z",
  fill: "#FEDB41"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.6176 9.67383V12.7797H16.043V9.67383H20.8309H25.6176Z",
  fill: "#FEDB41"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.7647 6.83447H20.8305H23.4498V9.66658H18.21V6.83447H20.7647Z",
  fill: "#00EFD1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.61753 49.9999C8.47568 49.9999 8.33703 49.9578 8.2191 49.879C8.10117 49.8001 8.00926 49.6881 7.95498 49.5571C7.90071 49.426 7.8865 49.2818 7.91417 49.1427C7.94183 49.0036 8.01012 48.8758 8.1104 48.7755L10.3974 46.4885C10.4635 46.42 10.5427 46.3654 10.6302 46.3278C10.7177 46.2902 10.8118 46.2704 10.9071 46.2696C11.0023 46.2687 11.0968 46.2869 11.1849 46.3229C11.2731 46.359 11.3532 46.4123 11.4205 46.4796C11.4879 46.547 11.5411 46.6271 11.5772 46.7152C11.6133 46.8034 11.6314 46.8978 11.6306 46.9931C11.6297 47.0883 11.61 47.1824 11.5724 47.2699C11.5348 47.3574 11.4801 47.4366 11.4116 47.5028L9.12465 49.7897C9.05815 49.8565 8.9791 49.9094 8.89207 49.9454C8.80504 49.9815 8.71174 50 8.61753 49.9999Z",
  fill: "#00EFD1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.6039 49.871C49.5097 49.8711 49.4164 49.8526 49.3293 49.8165C49.2423 49.7805 49.1633 49.7275 49.0968 49.6608L46.8098 47.3739C46.7413 47.3077 46.6866 47.2285 46.6491 47.141C46.6115 47.0535 46.5917 46.9594 46.5908 46.8641C46.59 46.7689 46.6082 46.6745 46.6442 46.5863C46.6803 46.4982 46.7336 46.4181 46.8009 46.3507C46.8683 46.2834 46.9483 46.2301 47.0365 46.194C47.1247 46.158 47.2191 46.1398 47.3143 46.1407C47.4096 46.1415 47.5037 46.1613 47.5912 46.1989C47.6787 46.2365 47.7579 46.2911 47.8241 46.3596L50.111 48.6466C50.2113 48.7469 50.2796 48.8747 50.3073 49.0138C50.3349 49.1529 50.3207 49.2971 50.2664 49.4282C50.2122 49.5592 50.1202 49.6712 50.0023 49.7501C49.8844 49.8289 49.7457 49.871 49.6039 49.871Z",
  fill: "#00EFD1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.8306 16.731C20.6403 16.731 20.4579 16.6554 20.3234 16.5209C20.1889 16.3864 20.1133 16.2039 20.1133 16.0137V15.2378C20.1133 15.0476 20.1889 14.8651 20.3234 14.7306C20.4579 14.5961 20.6403 14.5205 20.8306 14.5205C21.0208 14.5205 21.2033 14.5961 21.3378 14.7306C21.4723 14.8651 21.5479 15.0476 21.5479 15.2378V16.0137C21.5479 16.2039 21.4723 16.3864 21.3378 16.5209C21.2033 16.6554 21.0208 16.731 20.8306 16.731Z",
  fill: "#00ACEA"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2437 16.731C18.0534 16.731 17.871 16.6554 17.7365 16.5209C17.6019 16.3864 17.5264 16.2039 17.5264 16.0137V15.2378C17.5264 15.0476 17.6019 14.8651 17.7365 14.7306C17.871 14.5961 18.0534 14.5205 18.2437 14.5205C18.4339 14.5205 18.6163 14.5961 18.7509 14.7306C18.8854 14.8651 18.961 15.0476 18.961 15.2378V16.0137C18.961 16.2039 18.8854 16.3864 18.7509 16.5209C18.6163 16.6554 18.4339 16.731 18.2437 16.731Z",
  fill: "#00ACEA"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.4175 16.731C23.2272 16.731 23.0448 16.6554 22.9103 16.5209C22.7758 16.3864 22.7002 16.2039 22.7002 16.0137V15.2378C22.7002 15.0476 22.7758 14.8651 22.9103 14.7306C23.0448 14.5961 23.2272 14.5205 23.4175 14.5205C23.6077 14.5205 23.7902 14.5961 23.9247 14.7306C24.0592 14.8651 24.1348 15.0476 24.1348 15.2378V16.0137C24.1348 16.2039 24.0592 16.3864 23.9247 16.5209C23.7902 16.6554 23.6077 16.731 23.4175 16.731Z",
  fill: "#00ACEA"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.8306 20.0952C20.6403 20.0952 20.4579 20.0196 20.3234 19.8851C20.1889 19.7506 20.1133 19.5682 20.1133 19.3779V18.6021C20.1133 18.4118 20.1889 18.2294 20.3234 18.0949C20.4579 17.9603 20.6403 17.8848 20.8306 17.8848C21.0208 17.8848 21.2033 17.9603 21.3378 18.0949C21.4723 18.2294 21.5479 18.4118 21.5479 18.6021V19.3779C21.5479 19.5682 21.4723 19.7506 21.3378 19.8851C21.2033 20.0196 21.0208 20.0952 20.8306 20.0952Z",
  fill: "#00ACEA"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.2427 20.0952C18.0524 20.0952 17.87 20.0196 17.7355 19.8851C17.601 19.7506 17.5254 19.5682 17.5254 19.3779V18.6021C17.5254 18.4118 17.601 18.2294 17.7355 18.0949C17.87 17.9603 18.0524 17.8848 18.2427 17.8848C18.4329 17.8848 18.6154 17.9603 18.7499 18.0949C18.8844 18.2294 18.96 18.4118 18.96 18.6021V19.3779C18.96 19.5682 18.8844 19.7506 18.7499 19.8851C18.6154 20.0196 18.4329 20.0952 18.2427 20.0952Z",
  fill: "#00ACEA"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.4175 20.0952C23.2272 20.0952 23.0448 20.0196 22.9103 19.8851C22.7758 19.7506 22.7002 19.5682 22.7002 19.3779V18.6021C22.7002 18.4118 22.7758 18.2294 22.9103 18.0949C23.0448 17.9603 23.2272 17.8848 23.4175 17.8848C23.6077 17.8848 23.7902 17.9603 23.9247 18.0949C24.0592 18.2294 24.1348 18.4118 24.1348 18.6021V19.3779C24.1348 19.5682 24.0592 19.7506 23.9247 19.8851C23.7902 20.0196 23.6077 20.0952 23.4175 20.0952Z",
  fill: "#00ACEA"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.2959 26.3987H10.8613V5.31035C10.8613 4.61299 10.9987 3.92245 11.2656 3.27817C11.5324 2.63389 11.9236 2.04848 12.4167 1.55537C12.9098 1.06225 13.4952 0.671097 14.1395 0.404226C14.7838 0.137356 15.4743 0 16.1717 0C16.869 0 17.5596 0.137356 18.2039 0.404226C18.8481 0.671097 19.4336 1.06225 19.9267 1.55537C20.4198 2.04848 20.8109 2.63389 21.0778 3.27817C21.3447 3.92245 21.482 4.61299 21.482 5.31035V6.86209H20.0474V5.31035C20.0474 4.28243 19.6391 3.29662 18.9123 2.56977C18.1854 1.84292 17.1996 1.43458 16.1717 1.43458C15.1438 1.43458 14.1579 1.84292 13.4311 2.56977C12.7043 3.29662 12.2959 4.28243 12.2959 5.31035V26.3987Z",
  fill: "#F4B844"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.2667 46.8739C45.8252 47.6169 44.2344 48.0025 42.6218 48H15.3782C12.6257 47.9999 9.98604 46.8761 8.03977 44.8757C6.0935 42.8754 5.00006 40.1623 5 37.3333V32H53V37.3333C53.0004 39.3139 52.4643 41.2555 51.4517 42.9405C50.4391 44.6256 48.99 45.9876 47.2667 46.8739Z",
  fill: "#00ACEA"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 59,
    height: 50,
    viewBox: "0 0 59 50",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/bathroom.376809fb.svg";
export { SvgComponent as ReactComponent };